export default __webpack_public_path__ + "static/media/logorhombus.2731f147.svg";